'use client';

import { Arrow } from '@/ui/common/Arrows/ArrowDropdown';
import { ReactNode, useState } from 'react';

type TDescriptionProps = {
    children: ReactNode;
    description: string;
    status: string;
};

export const Description = ({ description, children, status }: TDescriptionProps) => {
    const [isOpen, setIsOpen] = useState(false);

    const onReadMore = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
        e.stopPropagation();
        e.preventDefault();

        setIsOpen((prev) => !prev);
    };

    const MINIMUM_CHARS = status ? 50 : 100;
    const showReadMore = MINIMUM_CHARS < description.length;

    return (
        <div
            className={`relative flex min-h-[144px] flex-col overflow-hidden px-3 py-6 duration-300 ${
                isOpen
                    ? 'max-h-[286px] shrink-0 md:max-h-[316px]'
                    : 'max-h-[154px] md:max-h-[144px]'
            }`}
        >
            {children}
            {!!status && (
                <div
                    data-test-id="card-status"
                    className="tx-medium-medium mt-2 flex items-center justify-center rounded-2xl bg-gray-4 px-4 py-2 text-gray-2 dark:bg-dark-1 dark:text-white"
                >
                    {status}
                </div>
            )}
            <div
                className={`custom-scroll tx-medium-regular mt-2 text-ellipsis break-words
                ${isOpen && 'w-[calc(100%+8px)] overflow-y-scroll pr-2'} ${
                    showReadMore && !isOpen ? 'overflow-hidden' : ''
                }`}
                data-test-id="card-description"
            >
                {description}
            </div>
            {showReadMore && (
                <p
                    className={`tx-large-medium absolute bottom-0 left-3 flex w-full bg-white text-brand dark:bg-dark-3 ${
                        !isOpen && 'shadow-[0px_-8px_16px_8px] shadow-white dark:shadow-dark-3'
                    }`}
                    onClick={onReadMore}
                >
                    {isOpen ? 'See less' : 'Read more'}
                    <Arrow toTop={isOpen} className="ml-2 duration-300" />
                </p>
            )}
        </div>
    );
};
